var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('p',{staticClass:"loader__label"},[_vm._v("Updating")]),_c('div',{staticClass:"loader__figure"})])
}]

export { render, staticRenderFns }